import React from 'react';

import { HB_PRIME_COLOR } from 'hb-redux-store/constants/halalboxPrime';

import './membership-order-item.scss';

const MembershipOrderItem = ({
  containerStyle = '',
  membershipDetails = {},
}) => {
  const {
    membershipTitle = '',
    retailPrice = 0,
    salePrice,
    saleOn,
    color = HB_PRIME_COLOR,
  } = membershipDetails;
  const onSale = saleOn && salePrice < retailPrice;
  const colorStyle = {
    color,
  };
  return (
    <div className={containerStyle} style={colorStyle}>
      {!!membershipTitle && <span>{membershipTitle}</span>}
      <div>
        <span
          className={`${
            onSale ? 'order-item-retail-price ' : 'order-item-sale-price'
          }`}
        >
          &#8377;{retailPrice}
        </span>
        {onSale && (
          <span className="order-item-sale-price">&#8377;{salePrice}</span>
        )}
      </div>
    </div>
  );
};

export default MembershipOrderItem;
